<template>
    <span class="hint pl-1">

        <btn theme="none" :icon="open ? 'close' : 'help'" class="hint-indicator"/>
        <popover direction="auto" class="popover-blue p-1" auto-bind @toggle="$log">
            <div class="hint-title" v-if="$slots.title || $scopedSlots.title || title">
                <slot name="title">{{ title }}</slot>
            </div>
            <slot>{{ text }}</slot>
        </popover>
    </span>
</template>

<script>
    export default {
        props: {
            title: {type: String, default: null},
            text: {type: String, default: ''},
        },

        data() {
            return {
                open: false,
            };
        },
    };
</script>